export const SELECTED_COMMUNITY = 'SELECTED_COMMUNITY'
export const TAB_SELECTED = 'TAB_SELECTED'
export const SAME_TAB = 'SAME_TAB'
export const EMAIL_VERIFICATION_CODE = 'EMAIL_VERIFICATION_CODE'
export const PARTNER_OPTIONS = 'PARTNER_OPTIONS'
